// extracted by mini-css-extract-plugin
module.exports = {"logo":"_3o8RV","link":"OZI14"};